module.exports = __webpack_public_path__ + "static/media/tour-partisipation.a53e12aa.svg";